(function () {
  'use strict';

  var ZOOM = 2;
  var OVERLAY_CLASS = 'ec-product-magnify-overlay';
  var INNER_CLASS = 'ec-product-magnify-overlay__img';

  function selectorImages() {
    return document.querySelectorAll(
      'product-info[data-zoom-on-hover] .ec-product-gallery__main-image.image-magnify-hover'
    );
  }

  function removeOverlaysInWrapper(wrap) {
    wrap.querySelectorAll('.' + OVERLAY_CLASS).forEach(function (n) {
      n.remove();
    });
  }

  function applyZoomAtPoint(inner, ow, oh, offsetX, offsetY) {
    if (ow < 2 || oh < 2) return;
    var x = Math.max(1, Math.min(ow - 1, offsetX));
    var y = Math.max(1, Math.min(oh - 1, offsetY));
    inner.style.transformOrigin = (x / ow) * 100 + '% ' + (y / oh) * 100 + '%';
    inner.style.transform = 'scale(' + ZOOM + ')';
  }

  function openMagnify(img, clientEvent) {
    var wrap = img.closest('.ec-product-gallery__main-image-wrapper');
    if (!wrap) return;
    removeOverlaysInWrapper(wrap);
    var w = img.offsetWidth;
    var h = img.offsetHeight;
    if (w < 1 || h < 1) return;
    var overlay = document.createElement('div');
    overlay.className = OVERLAY_CLASS;
    overlay.setAttribute('aria-hidden', 'true');
    var inner = document.createElement('img');
    inner.className = INNER_CLASS;
    inner.src = img.currentSrc || img.src;
    inner.alt = '';
    inner.draggable = false;
    inner.style.display = 'block';
    inner.style.width = '100%';
    inner.style.height = '100%';
    inner.style.objectFit = 'cover';
    inner.style.pointerEvents = 'none';
    inner.style.maxWidth = 'none';
    try {
      inner.style.objectPosition = window.getComputedStyle(img).objectPosition || 'center';
    } catch (e) {
      inner.style.objectPosition = 'center';
    }
    overlay.appendChild(inner);
    overlay.style.position = 'absolute';
    overlay.style.left = '0';
    overlay.style.top = '0';
    overlay.style.width = w + 'px';
    overlay.style.height = h + 'px';
    overlay.style.overflow = 'hidden';
    overlay.style.zIndex = '10';
    overlay.style.cursor = 'zoom-out';
    overlay.style.boxSizing = 'border-box';
    wrap.appendChild(overlay);
    function focusFromClient(ev) {
      var rect = overlay.getBoundingClientRect();
      var ox = ev.clientX - rect.left;
      var oy = ev.clientY - rect.top;
      applyZoomAtPoint(inner, overlay.clientWidth, overlay.clientHeight, ox, oy);
    }
    function applyInitialFocus() {
      var ox = w / 2;
      var oy = h / 2;
      if (clientEvent) {
        var ir = img.getBoundingClientRect();
        ox = clientEvent.clientX - ir.left;
        oy = clientEvent.clientY - ir.top;
      }
      applyZoomAtPoint(inner, w, h, ox, oy);
    }
    if (inner.complete && inner.naturalWidth > 0) {
      applyInitialFocus();
    } else {
      inner.onload = applyInitialFocus;
      inner.onerror = function () {
        overlay.remove();
      };
    }
    overlay.addEventListener('mousemove', function (e) {
      applyZoomAtPoint(inner, overlay.clientWidth, overlay.clientHeight, e.offsetX, e.offsetY);
    });
    overlay.addEventListener(
      'touchmove',
      function (e) {
        if (!e.touches.length) return;
        var rect = overlay.getBoundingClientRect();
        var t = e.touches[0];
        applyZoomAtPoint(inner, overlay.clientWidth, overlay.clientHeight, t.clientX - rect.left, t.clientY - rect.top);
      },
      { passive: true }
    );
    overlay.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      overlay.remove();
    });
    overlay.addEventListener('mouseleave', function () {
      overlay.remove();
    });
  }

  function bindClicks() {
    selectorImages().forEach(function (img) {
      if (img.dataset.ecMagnifyBound === '1') return;
      img.dataset.ecMagnifyBound = '1';
      img.addEventListener('click', function (e) {
        if (!this.closest('product-info[data-zoom-on-hover]')) return;
        var item = this.closest('.ec-product-gallery__main-item');
        if (item && !item.classList.contains('ec-product-gallery__main-item--active')) return;
        e.preventDefault();
        e.stopPropagation();
        openMagnify(this, e);
      });
    });
  }

  function init() {
    document.querySelectorAll('.ec-product-gallery__main-image.image-magnify-hover').forEach(function (img) {
      delete img.dataset.ecMagnifyBound;
    });
    bindClicks();
  }

  function runInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  runInit();

  document.addEventListener('product-info:loaded', function () {
    requestAnimationFrame(init);
  });

  document.addEventListener('shopify:section:load', function () {
    requestAnimationFrame(init);
  });

  function attachVariantSub() {
    if (window.__ecMagnifyVariantSub) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;
    window.__ecMagnifyVariantSub = true;
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      requestAnimationFrame(init);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachVariantSub);
  } else {
    attachVariantSub();
  }

  window.enableEcProductMagnify = init;
})();
